import { Box, Grid } from "@mui/material";
import CustomText from "../components/CustomText";
import Counter from "../components/Counter";

const stats = [
  {
    end: 9,
    label: "Niveles de infraestructura",
  },
  {
    end: 33,
    label: "Consultorios especializados",
  },
  {
    end: 5,
    label: "Códigos de emergencia atendidos",
  },
  {
    end: 600000,
    suffix: "+",
    label: "Personas en área de cobertura",
  },
  {
    end: 13100,
    suffix: "\nm²",
    label: "Área total de construcción",
  },
];

const CommitmentStats = () => {
  return (
    <Box sx={design.Container}>
      <CustomText sx={design.Tag}>MEDAM EN NÚMEROS</CustomText>
      <CustomText sx={design.Title}>
        La dimensión de nuestro
        <br />
        compromiso
      </CustomText>
      <Grid container sx={design.Grid}>
        {stats.map((item, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, md: 2.4 }} sx={design.Item}>
            <Counter end={item.end} suffix={item.suffix} sx={design.Number} />
            <CustomText sx={design.Label}>{item.label}</CustomText>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CommitmentStats;

const design = {
  Container: {
    py: 7,
    backgroundColor: "#F7F7F8",
    textAlign: "center",
  },
  Tag: {
    color: "#7A2FA4",
    fontWeight: 700,
    letterSpacing: 3,
    textTransform: "uppercase",
    mb: 2,
    fontFamily: "Nunito",
    fontSize: {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
    },
    lineHeight: "normal",
    textAlign: "center",
    width: "100%",
  },

  Title: {
    color: "#162E84",
    fontWeight: "bold",
    letterSpacing: 1,
    fontFamily: "Nunito",
    fontSize: {
      xs: 35,
      sm: 35,
      md: 35,
      lg: 40,
    },
    lineHeight: "normal",
  },

  Grid: {
    mt: 4,
    spacing: 4,
    justifyContent: "space-between",
  },

  Item: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  Number: {
    color: "#7A2EA8",
    fontFamily: "Nunito",
    fontSize: {
      xs: 42,
      md: 43,
    },
    fontWeight: 800,
    display: "flex",
    flexDirection: "row",
    gap: 0.5,
  },
  Label: {
    color: "#8A8A8A",
    fontFamily: "Nunito",
    fontSize: 17,
    fontWeight: 400,
    textAlign: "center",
  },
};
